module.exports = __webpack_public_path__ + "static/media/IMG_4260.0c1ce1bd.PNG";